import type { MutationCache } from '@tanstack/react-query';

export const getFilesCache = (
  mutationKey: string,
  mutationCache: MutationCache,
  value: any,
) => {
  if (Array.isArray(value)) {
    return mutationCache.findAll({
      mutationKey: [mutationKey],
      predicate: (mutation) => {
        const data = mutation.state.data as any;

        return value.includes(data.id);
      },
    });
  }

  return mutationCache.find({
    mutationKey: [mutationKey],
    predicate: (mutation) => {
      const data = mutation.state.data as any;

      return value === data.id;
    },
  });
};

export const openBlob = (file: Blob): void => {
  const fileURL = URL.createObjectURL(file);
  window.open(fileURL);
};
